import styled from "styled-components";

export const STFormWrapper = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  min-height: 150px;
  width: 92%;
  padding-top: 8px;
`;
